var lib_core = require("lib-core");

var SidebarView = require("./sidebarView.js");
var SidebarModel = require("./sidebarModel.js");
var SidebarStateMachine = require("./sidebarStateMachine.js");

var MasterController = require("./../master/masterController.js");

var SidebarController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(SidebarController, lib_core.Controller);
SidebarController.inject = {
    masterController : MasterController
};

SidebarController.prototype.afterLoad = function () {
    var self = this;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    this.masterController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};

SidebarController.prototype.createView = function () {
    return new SidebarView(this.getModel(), this.masterController.getView());
};

SidebarController.prototype.createModel = function () {
    return new SidebarModel(this.parent().getModel());
};

SidebarController.prototype.createStateMachine = function () {
    return new SidebarStateMachine(this.root, this.getModel());
};

module.exports = SidebarController;
